import { useState, useEffect, useCallback } from "react";
import { messagesService } from "@/api/services/messages.service";
export function useMessagesUnreadBadge({ type, entityId, contactId, }) {
    const [unreadCount, setUnreadCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const loadUnreadCount = useCallback(async () => {
        if (!entityId || !contactId) {
            setUnreadCount(0);
            return;
        }
        setIsLoading(true);
        try {
            const result = type === "job"
                ? await messagesService.getThreadByJob(entityId, contactId)
                : await messagesService.getThreadByQuote(entityId, contactId);
            const count = result?.thread?.unreadCount ?? 0;
            setUnreadCount(Math.max(0, typeof count === "number" ? count : 0));
        }
        catch {
            setUnreadCount(0);
        }
        finally {
            setIsLoading(false);
        }
    }, [type, entityId, contactId]);
    useEffect(() => {
        loadUnreadCount();
    }, [loadUnreadCount]);
    const clearBadge = useCallback(() => {
        setUnreadCount(0);
    }, []);
    return {
        unreadCount: contactId ? unreadCount : 0,
        isLoading,
        clearBadge,
    };
}
